import React from 'react'

interface ICustomSnackbarContext {
  snackbarMessage: string
  setSnackbarMessage: (value: string) => void | string
}

export const CustomSnackbarContext = React.createContext({
  snackbarMessage: '',
  setSnackbarMessage: (value) => '',
} as ICustomSnackbarContext)
